var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2GuestStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12435 6.1748C5.59406 6.1748 4.35352 7.41535 4.35352 8.94564C4.35352 10.4759 5.59406 11.7165 7.12435 11.7165C8.65464 11.7165 9.89518 10.4759 9.89518 8.94564C9.89518 7.41535 8.65464 6.1748 7.12435 6.1748Z",
    fill: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51286 12.5078C3.83195 12.5078 3.09095 12.9847 3.07142 13.8314C3.05774 14.4244 3.16386 15.2981 3.77963 16.0288C4.41026 16.777 5.47403 17.2578 7.12528 17.2578C8.77654 17.2578 9.84031 16.777 10.4709 16.0288C11.0867 15.2981 11.1928 14.4244 11.1792 13.8314C11.1596 12.9847 10.4186 12.5078 9.7377 12.5078H4.51286Z",
    fill: "#B9B9B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0014 2.21615H12.0729C13.2753 2.21615 14.25 3.19086 14.25 4.39323V17.4557C14.25 18.6581 13.2753 19.6328 12.0729 19.6328H2.17708C0.974716 19.6328 0 18.6581 0 17.4557V4.39323C0 3.19086 0.974716 2.21615 2.17708 2.21615H3.24862C3.50707 1.30236 4.3472 0.632812 5.34375 0.632812H8.90625C9.9028 0.632812 10.7429 1.30236 11.0014 2.21615ZM3.24862 3.40365H2.17708C1.63055 3.40365 1.1875 3.84669 1.1875 4.39323V17.4557C1.1875 18.0023 1.63055 18.4453 2.17708 18.4453H12.0729C12.6195 18.4453 13.0625 18.0023 13.0625 17.4557V4.39323C13.0625 3.84669 12.6195 3.40365 12.0729 3.40365H11.0014C10.7429 4.31743 9.9028 4.98698 8.90625 4.98698H5.34375C4.3472 4.98698 3.50707 4.31743 3.24862 3.40365ZM4.35417 2.8099C4.35417 3.35643 4.79718 3.79948 5.34375 3.79948H8.90625C9.45282 3.79948 9.89583 3.35643 9.89583 2.8099C9.89583 2.26336 9.45282 1.82031 8.90625 1.82031H5.34375C4.79718 1.82031 4.35417 2.26336 4.35417 2.8099Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2GuestStandard);
export default __webpack_public_path__ + "static/media/v2-guest-standard.27402934e1b0a4d75a0f930a2fd6876b.svg";
export { ForwardRef as ReactComponent };